import {useContext, useState} from "react";
import {RuoliContext} from "../../../../context/RuoliContext";
import ContenutoModelliArchivioView from "./ContenutoModelliArchivioView";

export default function ContenutoModelliArchivioController({
                                                              idMarca,
                                                              marca,
                                                              titoli,
                                                              handlerRefreshTitoli,
                                                              selectTitolo,
                                                          }) {

    const [showModalAddTitolo, setShowModalAddTitolo] = useState(false);

    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);

    return (
        <ContenutoModelliArchivioView
            titoli={titoli}
            idMarca={idMarca}
            marca={marca}
            isRuoloAd={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            openModalAddTitolo={() => {
                setShowModalAddTitolo(true);
            }}
            closeModalAddTitolo={() => {
                setShowModalAddTitolo(false);
            }}
            addTitoloOk={(titolo) => {
                setShowModalAddTitolo(false);
                handlerRefreshTitoli();
            }}
            showModalAddDoc={showModalAddTitolo}
            selectTitolo={selectTitolo}
        />
    );
}